<script setup lang="ts">
import { useDark } from '@vueuse/core'

import { Menu, PanelLeft, PanelLeftOpen } from 'lucide-vue-next'

defineProps<{
  isExpanded: boolean
}>()

const emit = defineEmits<{
  toggle: []
}>()

const isDark = useDark()
</script>

<template>
  <button
    @click="emit('toggle')"
    class="w-8 h-8 mt-1 cursor-pointer flex mx-auto items-center justify-center rounded-full transition-all duration-300 ease-in-out z-10"
    :class="
      isDark
        ? 'text-[var(--p-primary-color)] hover:bg-[var(--p-surface-800)]'
        : 'text-[var(--p-primary-contrast-color)] hover:bg-[var(--p-primary-contrast-color)]/20'
    "
  >
    <PanelLeft v-if="!isExpanded" :size="18" />
    <PanelLeftOpen v-else :size="18" />
  </button>
</template>